import { FeedbackRoute } from '@powerupsclub/feedback';
import {
  PaymentsContext,
  PaymentsContextProvider,
  PaymentsV3,
} from '@powerupsclub/payments';
import { TrelloPowerUpContextProvider } from '@powerupsclub/trello';
import { useContext } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from 'react-router-dom';
import { IframeConnector } from './components/IframeConnector';
import { Modal } from './components/Modal';
import { SendToBoard } from './components/SendToBoard';
import { LoggerErrorBoundary } from '@powerupsclub/logger';

const PaymentWrapper = () => {
  const history = useHistory();
  const { refetchSubscription } = useContext(PaymentsContext);

  const returnPath = `/modal`;

  return (
    <PaymentsV3
      onComplete={async () => {
        await refetchSubscription({ waitForStatus: 'active' });
        history.push(returnPath);
      }}
      onDismiss={async () => history.push(returnPath)}
    />
  );
};

function App() {
  return (
    <LoggerErrorBoundary powerUpKey="archiveManager">
      <Router
        basename={
          process.env.NODE_ENV === 'development'
            ? undefined
            : '/archive-manager'
        }
      >
        <Switch>
          <Route exact path="/iframeConnector" component={IframeConnector} />
          <TrelloPowerUpContextProvider
            appKey="33c0c8cc351e11ca11c38efc8f48e1ce"
            appName="Archive Manager"
            powerUpKey="archiveManager"
            localization={{
              defaultLocale: 'en',
              supportedLocales: ['en'],
              resourceUrl:
                process.env.NODE_ENV === 'development'
                  ? '/strings/{locale}.json'
                  : '/archive-manager/strings/{locale}.json',
            }}
          >
            <PaymentsContextProvider>
              <Route exact path="/modal">
                <Modal />
              </Route>
              <Route exact path="/send-to-board">
                <SendToBoard />
              </Route>
              <Route exact path="/payment">
                <PaymentWrapper />
              </Route>
              <FeedbackRoute />
            </PaymentsContextProvider>
          </TrelloPowerUpContextProvider>
        </Switch>
      </Router>
    </LoggerErrorBoundary>
  );
}

export default App;
